<template>
	<div class="loginContainer">
		<div class="loginBox">
			
			<div class="loginBoxImgLeft"></div>
			<div class="loginBoxRight" v-if="flag">
				<div class="titleBox1">兰树</div>
				<!-- <div class="titleBox2">我们传播美·奉献爱</div> -->
				<el-form  ref="loginFormRef" :model="loginForm" :rules="loginFormRules" label-width="0px"  class="login_form">
					<el-form-item prop="username">
						<el-input  class="usernameBox" placeholder="请输入用户名"  v-model="loginForm.username" prefix-icon="el-icon-user"></el-input>
					</el-form-item>
					<el-form-item prop="password">
						<el-input class="passwordBox" type="password" placeholder="请输入密码" @keyup.enter.native="userLogin()" prefix-icon="el-icon-goods" v-model="loginForm.password"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button class="loginBtn" type="primary" @click="userLogin()">登录</el-button>
					</el-form-item>
				</el-form>
				<div class="titleBox3">
					<a @click="enterHome">返回首页</a> <br/>
					暂无账号 <font @click="change">马上注册></font>
				</div>
				
			</div>
			
			
			<div class="loginBoxRight" v-else>
				<div class="loginIconBox" @click="change">
					<img class="userloginImg" src="../assets/login/userLogin.png" alt="">
					<img class="loginBack" src="../assets/login/loginBack.png" alt="">
				</div>
				<div class="titleBox1">兰树</div>
				<!-- <div class="titleBox2">我们传播美·奉献爱</div> -->
				<!-- <el-input class="usernameBox" placeholder="请输入用户名" prefix-icon="el-icon-date" v-model="registerUsername"></el-input>
				<el-input class="passwordBox" placeholder="请输入密码" prefix-icon="el-icon-date" v-model="registerPassword"></el-input>
				<el-button class="loginBtn" type="primary">注册</el-button> -->
				<el-form :model="ruleForm" ref="ruleForm" :rules="registerRules"  class="login_form" label-width="0px">
					 <el-form-item  prop="username">
						<el-input class="usernameBox" placeholder="请输入用户名" prefix-icon="el-icon-date" v-model="ruleForm.username"></el-input>
					</el-form-item>
					<el-form-item   prop="password">
						<el-input class="passwordBox" type="password" placeholder="请输入密码" @keyup.enter.native="userRegister()" prefix-icon="el-icon-date" v-model="ruleForm.password"></el-input>
					</el-form-item>
					<el-form-item >
						<el-button class="loginBtn" type="primary" @click="userRegister()">注册</el-button>
					</el-form-item>
					<div class="registerTitle">
						注册即同意<a>《兰树服务协议》</a>
					</div>
            </el-form>
			</div>
		</div>
	</div>
</template>

<script>
	import {login,myPost,myGet} from "../api/http.js";
	export default{
		data(){
			return{
				// 验证码
				codenput:'',
				disabled:false,
				flag:true,
				btnName:'注册',
				loginForm:{
					username:'',
					password:'',
				},
				ruleForm:{
					 username:'',
					 password:'',
				},
				// 登录规则
				loginFormRules:{
					username:[
						{ required: true, message: '请输入用户名', trigger: 'blur' },
						{ min: 3, max: 15, message: '长度在 3 到 10 个字符', trigger: 'blur' }
					],
					password:[ 
						 { required: true, message: '请输入密码', trigger: 'blur' },
						 { min: 6, max: 15, message: '长度在 6 到 15 个字符', trigger: 'blur' }
					]
            },
			// 注册表单的验证规则
            registerRules: {
                username:[
                	{ required: true, message: '请输入用户名', trigger: 'blur' },
                	{ min: 3, max: 15, message: '长度在 3 到 10 个字符', trigger: 'blur' }
                ],
                password:[ 
                	 { required: true, message: '请输入密码', trigger: 'blur' },
                	 { min: 6, max: 15, message: '长度在 6 到 15 个字符', trigger: 'blur' }
                ]
            }
			}
		},
		methods:{
			change(){
				this.flag = !this.flag;
// 				if(this.flag){
// 					this.btnName = '登录'
// 				}else{
// 					this.btnName= '注册'
// 				}
			},
			// 登录
			userLogin(){
				myPost("login/",{
					username:this.loginForm.username,
					password:this.loginForm.password,
				}).then((res) =>{
					if(res.data.code == 200){
						this.$router.push({path:'/'});
					}
				})
			},
			//注册
			userRegister(){
				myPost("register/",{
					username:this.ruleForm.username,
					password:this.ruleForm.password,
				}).then((res)=>{
					if(res.data.code == 200){
						this.change()
					}
				})
			},
			enterHome(){
				this.$router.push({path:'/'});
			}
      } 
		
	}
</script>

<style scoped>
	.loginContainer{
		width: 100%;
		height: 100%;
		background: url(https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_10-37-23_24444.png) no-repeat;
		background-size:100%;
		background-position: 100% 100%;
		position: fixed;
		margin: 0;
		padding: 0;
		left: 0;
		top: 0;
	}
	
	
	.loginBox{
		width: 70%;
		margin: 0 auto;
		display: flex;
		height: 80%;
		align-items: center;
		margin-top: 5%;
	}
	
	/* .loginBoxOut{
		width: 100%;
		display: flex;
		flex-direction:column;
		align-items: center;
		justify-content: center;
	} */
	
	.loginBoxImgLeft{
		width:60%;
		height: 100%;
		background: url(https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_10-37-57_513.png) no-repeat;
		background-size:cover;
	}
	
	
	
	.loginBoxRight{
		width: 40%;
		height: 100%;
		float: right;
		background-color: #FFFFFF;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	
	
	.titleBox1{
		font-size:2rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #111111;
		line-height: 45px;
		margin-top: 10%;
	}
	
	.titleBox2{
		font-size:0.875rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		line-height: 20px;
		margin-top: 0.5rem;
	}
	
	
	.phoneInput{
		width: 100%;
	}
	
	.codeBox{
		width:80%;
		display: flex;
		flex-direction: row;
		margin-top: -1em;
	}
	
	.codeItem{
		width: 90%;
		margin-right: 0.5rem;
	}
	
	.registerBtn{
		width: 80%;
		margin-top: 2rem;
	}
	
	.titleBox3{	
		font-size:0.875rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 200;
		color: #222222;
		line-height: 20px;
		position: absolute;
		bottom: 15%;
		text-align: center;
	}
	
	.titleBox3 a{
		cursor: pointer;
	}
	
	.titleBox3 a:hover {
		color: #0000CC;
	}
	
	.titleBox3 font{
		color: #0148C2;
		cursor: pointer;
	}
	
	
	
	
	.phoneForm{
		width: 80%;
		margin: 0 auto;
		margin-top: 2rem;
	}
	
	.bottomBox{
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-top:20%;
	}


	.wechatBox{
		display: flex;
		flex-direction: column;
		align-items: center;
		cursor: pointer;
		
	}
	
	.wechatImg{
		width: 30%;
	}
	
	.zhifuImg{
		width: 25%;
	}
	
	.zhifuBox{
		display: flex;
		flex-direction: column;
		align-items: center;
		cursor: pointer;
		margin-left: 1em;
	}
	
	
	
	.wechatTitle{	
		font-size:0.875rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		line-height: 20px;
	}
	
	.loginTitle1{	
		font-size:1rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #222222;
		line-height: 22px;
		margin-top: 3em;
	}
	
	
	.loginTitle2{	
		font-size:0.875rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		line-height: 20px;
		margin-top: 1em;
	}
	
	.loginIconBox{
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		align-items: center;
		cursor: pointer;
	}
	
	.userloginImg{
		position: relative;
		top:1em;
		left:1em;
	}
	
	
	.loginImgLeft{
		float: left;
		width: 60%;
	}
	
	.usernameBox{
		width: 100%;
		margin: 0 auto;
		margin-top: 1rem;
	}
	
	.passwordBox{
		width: 100%;
		margin: 0 auto;
	}
	
	.loginBtn{
		width: 100%;
		margin: 0 auto;
		margin-top: 1rem;
	}
	
	.registerTitle{
		font-size:0.875rem;
		font-family: MicrosoftYaHei;
		color: #222222;
		line-height: 16px;
		margin-top: 1rem;
	}
	
	.registerTitle a{
		text-decoration: none;
		color: #0C4DBE;
		cursor: pointer;
	}
	
	.login_form{
		width:65%;
	}
</style>



// WEBPACK FOOTER //
// src/components/login.vue